import { createContext, useContext, useEffect, useState } from "react";
import { loadDatabase, executeQuery } from "../database/db";
import { saveHistory, getHistory } from "../database/history";

const DBContext = createContext();

export function DBProvider({ children }) {
  const [dbLoaded, setDbLoaded] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    loadDatabase().then(() => {
      setDbLoaded(true);
      setHistory(getHistory());
    });
  }, []);

  const runQuery = (query) => {
    const result = executeQuery(query);
    saveHistory(query);
    setHistory(getHistory());
    return result;
  };

  const value = { dbLoaded, runQuery, history };
  return <DBContext.Provider value={value}>{children}</DBContext.Provider>;
}

export const useDB = () => useContext(DBContext);
